var __isMobile = false
function callback(mm) {
  if (mm.matches) { // If media query matches
    __isMobile = true
  } else {
   __isMobile = false
  }
}

const mm = window.matchMedia("(max-width: 799px)")
callback(mm) // Call listener function at run time
mm.addListener(callback) // Attach listener function on state changes